export interface ProtocolsViewerVm {
    type: 'protocols';
    value: string[];
}

export default function buildProtocolsViewer(value: string[]): ProtocolsViewerVm {
    return { type: 'protocols', value: value.filter((protocol) => protocol != 'ogp') };
}
